module.exports = __webpack_public_path__ + "img/video-slide-2.74272156.jpg";